class UnionMemberModel {
  union_id = null;
  professional_group_id = null;
  join_date = null;
  leave_date = null;
  constructor(unionMemberData) {
    if (unionMemberData !== undefined) {
      let {
        union_id,
        professional_group_id,
        join_date,
        leave_date
      } = unionMemberData;
      Object.assign(this, {
        union_id,
        professional_group_id,
        join_date,
        leave_date
      });
    }
  }
}

export default UnionMemberModel;
